/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SeoJobRoleSkillsAndLocationsQueryVariables = Types.Exact<{
  serpType: Types.Scalars['String']['input'];
  jobRole: Types.Scalars['String']['input'];
}>;

export type SeoJobRoleSkillsAndLocationsQuery = {
  __typename?: 'Query';
  seoJobRoleSkills?: {
    __typename?: 'SeoJobRoleSkillsCollection';
    collection: Array<{
      __typename?: 'SeoJobRoleSkills';
      name?: string | null;
      seoName?: string | null;
      jobCount?: number | null;
      url?: string | null;
    } | null>;
  } | null;
  seoJobRoleLocations?: {
    __typename?: 'SeoJobRoleLocationsCollection';
    collection: Array<{
      __typename?: 'SeoJobRoleLocations';
      name?: string | null;
      seoName?: string | null;
      jobCount?: number | null;
      url?: string | null;
    } | null>;
  } | null;
};

export const SeoJobRoleSkillsAndLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'seoJobRoleSkillsAndLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'serpType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobRole' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seoJobRoleSkills' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'serpType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'serpType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobRole' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobCount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seoJobRoleLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'serpType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'serpType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobRole' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobCount' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SeoJobRoleSkillsAndLocationsQuery,
  SeoJobRoleSkillsAndLocationsQueryVariables
>;
